export enum StorageKeys {
	token = "accessToken",
	name = "name",
	role = "role",
}
